import { types } from 'mobx-state-tree';

export const Wholesaler = types.model('Wholesaler', {
  _id: types.identifier,
  name: types.string,
  email: types.string
});
